import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    defaultMessage: 'Do you want to add more banks?',
    id: 'Multibanking.title',
  },
  subTitle: {
    defaultMessage: 'Connect your other banks and accounts to get the most suitable offer.',
    id: 'Multibanking.subTitle',
  },
  addBank: {
    defaultMessage: 'Add another bank',
    id: 'Multibanking.addBank',
  },
  noThanks: {
    defaultMessage: 'No thanks',
    id: 'Multibanking.noThanks',
  },
});
